import React, { useEffect, useState } from 'react';
import { MailBoxContainer } from './style';
import MailMessagesListBoxUI from './MailMessagesListBoxUI';
import { MAIL_NAV_LIST } from '../../contants/mailPageConstants';
import { skeleton } from './skeleton';
import { useAuth } from '../../hooks/useAuth';
import { useSelector, useDispatch } from 'react-redux';
import { selectMailData, selectMailStatus, selectMailError, initializeAsync } from './mailSlice';

function MailBoxPage() {
    const data = useSelector(selectMailData);
    const status = useSelector(selectMailStatus);
    const error = useSelector(selectMailError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const [mailMessageAllDataList, setMailMessageAllDataList] = useState(data?.records ? data.records : []);

    const [selectedNavItem, setSelectedNavItem] = useState(MAIL_NAV_LIST[0]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setMailMessageAllDataList(data?.records ? data.records : []);
    }, [data?.records]);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(initializeAsync({ accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }));
        }
    }, [status, dispatch]);

    return status === 'initialLoading' || status === 'idle' ? (
        skeleton
    ) : (
        <MailBoxContainer>
            <MailMessagesListBoxUI
                selectedNavItem={selectedNavItem}
                setSelectedNavItem={setSelectedNavItem}
                mailMessageAllDataList={mailMessageAllDataList}
                setMailMessageAllDataList={setMailMessageAllDataList}
                userDetails={userDetails}
            />
        </MailBoxContainer>
    );
}

export default MailBoxPage;
